import axios from 'axios'
import * as React from 'react'
import ButtonAction from 'components/shared/ButtonAction'
import { useState, useCallback } from 'react'
import { useTheme } from '@material-ui/core/styles'
import useCredentials from '../hooks/useCredentials'

const RevertButton: React.FC<{ id: string; className?: string; reloadOrganization: () => void }> = ({ className = '', id, reloadOrganization }) => {
  const { credentials } = useCredentials()
  const [loading, setLoading] = useState(false)
  const theme = useTheme()

  const handleClick = useCallback(async () => {
    try {
      setLoading(true)
      await axios.put(`/api/panel/organizations/${id}/revert_settings`, {}, { headers: credentials })
      reloadOrganization()
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }, [credentials, id, reloadOrganization])

  return (
    <ButtonAction
      text='Revert Changes'
      variant='outlined'
      color='info'
      className={className}
      type='button'
      onClick={handleClick}
      loading={loading}
      loaderColor='#000'
    />
  )
}

export default RevertButton
